import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';

import { enterpriseUserClient } from 'clients';
import rollbarLogger from 'config/rollbar';
import { useUser } from 'store/modules/users/hooks';
import { UserRole } from 'types/models/membership';
import User from 'types/models/user';
import { APIResponseParsed } from 'types/response';

type UseAdminUsers = (enterpriseId?: number) => { adminUsers: User[], isLoading: boolean };

export const useAdminUsers: UseAdminUsers = (
  enterpriseId
) => {
  const allAdminUsers = useUser(UserRole.ADMIN);
  const [adminUsers, setAdminUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchAdminUsers = async (_enterpriseId: number) => {
      const response: APIResponseParsed<User[]> = await enterpriseUserClient.fetchUsers({
        enterpriseId: _enterpriseId,
        role: UserRole.ADMIN
      });
      if (response.error) {
        rollbarLogger.error('[useAdminUsers] Error fetching enterprise\'s admin users', {
          enterpriseId: _enterpriseId,
          role: UserRole.ADMIN,
          error: response.error
        });
        Sentry.logger.error('[useAdminUsers] Error fetching enterprise\'s admin users', {
          enterpriseId: _enterpriseId,
          role: UserRole.ADMIN,
          error: response.error
        });
        setAdminUsers([]);
      } else {
        setAdminUsers(response.data);
      }
      setIsLoading(false);
    };

    setIsLoading(true);
    if (enterpriseId) {
      fetchAdminUsers(enterpriseId);
    } else {
      setAdminUsers(allAdminUsers);
      setIsLoading(false);
    }
    setIsLoading(true);
  }, [enterpriseId, allAdminUsers]);

  return { adminUsers, isLoading };
};